<div id="header" class="flex flex-col sm:flex-row md:flex-col flex-auto justify-between py-4 border-b">
    <!-- Main actions -->
    <div class="flex items-center">
        <!-- Select  -->
        <div class="flex-auto">
            <mat-form-field class="fuse-mat-no-subscript w-[100%] sm:w-[90%] top-[5px]">
                <mat-select [placeholder]="'label_search' | translate" (selectionChange)="searchContext($event.value)">
                    <mat-option [value]="null">{{ 'label_all' | translate }}</mat-option>
                    @for (context of contextList; track context) {
                        <mat-option [value]="context.viewValue">{{ context.viewValue }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <!-- Search -->
        <div class="flex-auto">
            <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full min-w-50">
                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
                <input matInput [placeholder]="'label_search' | translate" (keyup)="searchFilter($event.target.value)" />
            </mat-form-field>
        </div>
        <!-- Add contact button -->
        @if (lsrauthService.inRole(userDetails, userRoles.CONFIGS_SUPERUSER_ROLE)) {
            <button class="ml-4" mat-flat-button [color]="'primary'" (click)="addSettings()">
                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                <span class="ml-2 mr-1 hidden md:block">{{ 'label_register' | translate }}</span>
            </button>
        }
    </div>
</div>

<form [formGroup]="form" class="flex-auto">
    <div class="max-w-full overflow-x-auto">
        <table matSort mat-table [dataSource]="dataSource" class="w-full">
            <ng-container matColumnDef="context">
                <th mat-sort-header="context" mat-header-cell *matHeaderCellDef>
                    {{ 'label_area' | translate }}
                </th>
                <td mat-cell *matCellDef="let group" [formGroup]="group">
                    {{ group.get('context').value }}
                </td>
            </ng-container>

            <ng-container matColumnDef="key">
                <th mat-sort-header="key" mat-header-cell *matHeaderCellDef>
                    {{ 'label_name' | translate }}
                </th>
                <td mat-cell *matCellDef="let group" [formGroup]="group">
                    {{ group.get('key').value }}
                </td>
            </ng-container>

            <ng-container matColumnDef="value">
                <th mat-sort-header="value" mat-header-cell *matHeaderCellDef>
                    {{ 'label_value' | translate }}
                </th>
                <td mat-cell *matCellDef="let group" [formGroup]="group">
                    <mat-form-field>
                        <input type="text" matInput formControlName="value" />
                        @if (checkHasChanges(group.get('id').value)) {
                            <mat-icon
                                class="icon-size-5"
                                svgIcon="mat_solid:edit"
                                [matTooltip]="getInitialValue(group.get('id').value)"
                            ></mat-icon>
                        }
                    </mat-form-field>
                </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-sort-header="action" mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let group">
                    <span>
                        <!-- Delete config settins -->
                        @if (lsrauthService.inRole(userDetails, userRoles.CONFIGS_SUPERUSER_ROLE)) {
                            <button mat-icon-button (click)="deleteConfigs(group.get('id').value)" [matTooltip]="'Eyða gildi'">
                                <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                            </button>
                        }
                    </span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
        </table>
    </div>
    <mat-paginator #tablePaginator class="justify-end" showFirstLastButtons [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 50]">
    </mat-paginator>

    <!-- buttons -->
    <div class="flex items-center justify-end mt-4">
        <button mat-stroked-button type="button" [disabled]="pendingChanges.length == 0 || form.pristine" (click)="resetValues()">
            {{ 'label_clear_changes' | translate }}
        </button>
        <button
            class="ml-4"
            mat-flat-button
            type="submit"
            [disabled]="pendingChanges.length == 0 || !form.valid"
            (click)="save()"
            [color]="'primary'"
        >
            {{ 'label_save' | translate }}
        </button>
    </div>
</form>
